import React from 'react'
import { createBrowserRouter } from 'react-router-dom'

import NotFound from '../components/NotFound'
import Page from '../components/Page'
import Posts from '../components/Posts'
import SinglePost from '../components/SinglePost'
import SingleProject from '../components/SingleProject'
import PageTransition from '../components/templateParts/PageTransition'
import Layout from '../Layout'
import paths from './paths'
import { routerGuard } from './routerGuard'
import { pageFromPath } from './utils'

const { show_on_front, page_for_posts, page_on_front, permalink_structure } =
  window.__REACT_WORDPRESS__.routing

const permalinkRoute = permalink_structure.replace('%postname%/', '')

const postsPageRoute =
  show_on_front === 'page' && page_for_posts
    ? {
        path: `/${page_for_posts}`,
        element: (
          <PageTransition>
            <Posts page={pageFromPath(paths.postsPage(page_for_posts))} slug={page_for_posts} />
          </PageTransition>
        ),
        id: 'Posts',
        errorElement: <NotFound />,
      }
    : null

const rootRoute =
  show_on_front === 'page' && page_on_front
    ? {
        path: '/',
        element: <Page slug={page_on_front} isHomepage={true} showIntro={true} />,
        id: 'Home',
        loader: (e) => routerGuard({ routeData: e, homePage: true }),
        errorElement: <NotFound />,
      }
    : null

export default function routes() {
  return createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      id: 'Layout',
      children: [
        rootRoute,
        postsPageRoute,
        {
          path: '/404',
          element: <NotFound />,
          id: 'NotFound',
        },
        {
          path: '/projects/:slug',
          element: <SingleProject />,
          id: 'SingleProject',
          loader: (e) => routerGuard({ routeData: e, type: 'projects' }),
        },
        {
          path: `${permalinkRoute}:slug`,
          element: <SinglePost newsSlug={page_for_posts} />,
          loader: (e) => routerGuard({ routeData: e, type: 'posts' }),
          id: 'SinglePost',
        },
        {
          path: '/:slug',
          element: <Page />,
          loader: (e) => routerGuard({ routeData: e, type: 'pages' }),
          id: 'Page',
        },
      ].filter((route) => route),
      errorElement: (
        <Layout>
          <NotFound />
        </Layout>
      ),
    },
  ])
}
